import { render, staticRenderFns } from "./rfq-details-form.vue?vue&type=template&id=4250f02a"
import script from "./rfq-details-form.vue?vue&type=script&lang=js"
export * from "./rfq-details-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports